import styled from 'styled-components';
import {borderTop1px} from '../../../utils/style/mixin';

const ItemContainer = styled.div`
display: flex;
flex-direction: row;
${borderTop1px({})};
width: 100%;
height: 2.5rem;
background-color: #fff;
z-index: 10;
padding: .2rem;
`;

const ImageComtainer = styled.div`
position: relative;
width: 3.12rem;
height: 2.1rem;
margin-right: .16rem;
overflow: hidden;
img {
width: 100%;
height: 100%;
}
.icon-corner-sign{
position: absolute;
top: 0;
left: 0;
display: block;
line-height: 1;
padding: .06rem .24rem;
background: #c71622;
border-bottom-right-radius: .7rem;
color: #fff;
&.over{
color: #fff;
background-color: #8a8a8a;
}
}
`;

const InfoComtainer = styled.div`
flex: 1;
display: flex;
flex-direction: column;
justify-content: space-between;
`;

const InfoTitle = styled.div`
word-break: break-all;
font-size: .3rem;
color: #433e33;
line-height: .36rem;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden;
height: .71rem;
`;

const InfoDetail = styled.div`
.p-middle{
color: #999;
.p-price{
font-size: .24rem;
margin-bottom: .1rem;
.price-num{
margin-left: .1rem;
font-size: .42rem;
font-weight: 700;
color: #cc2729;
&.price-small{
font-size: .3rem;
}
}
}
.p-category{
font-size: .24rem;
i{
color: #000015;
}
}
}
.p-bid{
font-size: .24rem;
color: #999;
font-family: PingFangSC-Light;
margin-top: 0.2rem;
.p-bid-divide{
display: inline-block;
margin: 0 .1rem .02rem;
width: 1px;
height: .2rem;
vertical-align: middle;
background-color: silver;
}
i{
color: #b15f01;
}
}
`;

export {
  ItemContainer,
  ImageComtainer,
  InfoComtainer,
  InfoTitle,
  InfoDetail,
};
